module.exports = __webpack_public_path__ + "static/img/qr1.869e01c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr1.jpg
// module id = IwyG
// module chunks = 1